import React from 'react';
import { PlanTabKey } from './PlanTabs';
import PlanCalendarNetBody from './PlanCalendarNetBody';
import WorkInboxBody from '../work/WorkInboxBody';
import PlanDeadlinesNetBody from './PlanDeadlinesNetBody';
import ApplyLeave from '../../../components/organization/hr/ApplyLeave';
import MyLeavePeriod from '../../../components/organization/hr/MyLeavePeriod';
import MyAttendance from '../../../components/organization/hr/MyAttendance';
import Drawer from '../../../components/common/Drawer';
import '../../../components/layout/ModuleLayout.css';

interface Task {
  id: number;
  type: string;
  title: string;
  dueDate: string;
  status: string;
  priority: string;
  context: string;
  description: string;
  createdBy?: string;
  createdOn?: string;
}

const MOCK_LEAVES = {
  balance: { casual: 5, sick: 8, privilege: 12 },
  history: [
    { id: 1, type: 'Casual', from: '2024-05-25', to: '2024-05-26', days: 2, status: 'Applied', reason: 'Personal work' },
    { id: 2, type: 'Sick', from: '2024-04-10', to: '2024-04-10', days: 1, status: 'Sanctioned', reason: 'Fever' },
    { id: 3, type: 'Privilege', from: '2024-06-10', to: '2024-06-14', days: 5, status: 'Applied', reason: 'Family Vacation' },
  ],
};

interface PlanNetBodyProps {
  activeTab?: PlanTabKey;
  // Real, adapted tasks fed from the application3 PlanView wrapper — sourced from
  // tasksService.list({ mine: true }), which is scoped to the logged-in user's
  // tasks in the currently-selected (login) entity only. When empty, the
  // Deadlines tab renders an empty state (no mock fallback).
  tasks?: Task[];
  rawTasks?: any[];
  inboxLoading?: boolean;
  asideOpen?: boolean;
  onAsideToggle?: () => void;
}

const PlanNetBody: React.FC<PlanNetBodyProps> = ({ activeTab = 'calendar', tasks = [], asideOpen = false, onAsideToggle }) => {
  const deadlineTasks = tasks;
  const renderPanel = () => {
    if (activeTab === 'calendar')
      return (
        <div className="flex flex-row gap-2 h-full min-h-0 items-stretch">
          <div className="plan-inbox-pane flex-[2] min-w-0 flex flex-col">
            <WorkInboxBody />
          </div>
          <div className="w-px self-stretch bg-gray-200" aria-hidden="true" />
          <div className="flex-[3] min-w-0 flex flex-col">
            <PlanCalendarNetBody leaves={MOCK_LEAVES.history} />
          </div>
        </div>
      );
    if (activeTab === 'leaves_applied') return <ApplyLeave />;
    if (activeTab === 'leaves_sanctioned') return <MyLeavePeriod />;
    if (activeTab === 'my_attendance') return <MyAttendance />;
    if (activeTab === 'deadlines') return <PlanDeadlinesNetBody tasks={deadlineTasks} />;
    return null;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
      <Drawer isOpen={asideOpen} onClose={onAsideToggle ?? (() => {})}>
        <div className="aside-card">
          <h3>Scheduler Overview</h3>
          <p>• <strong>Calendar</strong> — Visual planning</p>
          <p>• <strong>Leaves</strong> — Balance & history</p>
          <p>• <strong>Deadlines</strong> — All tasks</p>
        </div>
        <div className="aside-card">
          <h3>Leave Statuses</h3>
          <p>• Applied (pending approval)</p>
          <p>• Sanctioned (approved)</p>
          <p>• Balance tracking</p>
        </div>
      </Drawer>
    </div>
  );
};

export default PlanNetBody;
